module.exports = __webpack_public_path__ + "img/yoga.926ae743.svg";